export default "__VITE_ASSET__c9d8fb4f__"